import { Component, Input } from "@angular/core";
import { Menu } from "@edp-models/menu.model";
import { EdpUser } from "@edp-models/user.model";


@Component({
    selector: "app-edp-submenu",
    templateUrl: "./edp-submenu.component.html",
    styleUrls: ["./edp-submenu.component.scss"],
})
export class EdpSubmenuComponent {
    @Input() submenu: Menu[];
    @Input() user: EdpUser;
}
